import { ValidatorFn, NgModel, AbstractControl } from '@angular/forms';

export function mustBeDifferentThanValidator(compareAgainstModel: NgModel): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    let result = null;
    if (control.value != null && control.value === compareAgainstModel.value) {
      result = { 'mustBeDifferentThan': { value: control.value } };
    }

    setTimeout(() => compareAgainstModel.control.updateValueAndValidity());
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/must-be-different-than.ts